import { Vue, Component, Prop } from 'vue-property-decorator';
import { PERMISSION_CHECK } from '@/utils/constants';
import { rosterAPI } from '@/providers/apis/roster/roster';
import { CUSTOM_ROSTER_SELECTION_TYPE } from '@/utils/constants';
import CreateNewUSerLayout from '@/routers/m-views/m-create-new-user/m-create-new-user';
import RosterUpload from '@/routers/m-views/m-setup/m-roster-setup/m-tenant-data/m-roster-upload/m-roster-upload';

@Component({
    name: 'users-component',
    components: {
        'm-roster-upload': RosterUpload,
        'm-create-student-layout': CreateNewUSerLayout,
    },
})
export default class Users extends Vue {

    // --------------------------------------------------------
    // Properties

    private isCreateShowPullup: boolean = false;

    private permissonCheck = PERMISSION_CHECK;

    private isPermissionCheck: boolean = false;

    private rosterFile: any = null;

    private tenantId: string = '';

    private userId: string = '';

    private perPage: number = 10;

    private selectedCustomType: any = CUSTOM_ROSTER_SELECTION_TYPE[0].identifier;

    private fieldItems: any = [];

    private isLoading: boolean = false;

    private customRosterData: any = [];

    private isUploadedSuccessfully: boolean = false;

    private isRefreshRosterdata: boolean = false;

    private classCode: any = null;

    // ----------------------------------------------------------------
    // Hooks
    private created() {
        this.isPermissionCheck = this.$access.isHavingPermisson(this.permissonCheck.rosterMobileView);
        this.tenantId = this.$access.getTenantId();
        this.userId = this.$access.getUserId();
        this.classCode = this.$route.query.class_code;
    }

    // ------------------------------------------------------------------
    // Actions
    private onAddstudent() {
        this.isCreateShowPullup = true;
        const element: HTMLElement | any =  document.querySelector('body');
        element.style.overflow = 'hidden';
    }

    private onPickFile() {
        (this.$refs.fileInput as any).click();
    }
    private onFilePicked(event: any) {
        this.rosterFile = event.target.files[0];
        this.rosterCustomAPI();
    }
    private onClosePullup() {
        this.isUploadedSuccessfully = false;
        this.noScrollable();
    }
    private onOverallClose() {
        this.isCreateShowPullup = false;
        this.isRefreshRosterdata = !this.isRefreshRosterdata;
        this.noScrollable();
    }
    private onClose() {
        this.isCreateShowPullup = false;
        this.noScrollable();
    }
    // ---------------------------------------------------------------------
    // Methods
    private validationToastMessage() {
        this.$bvToast.toast(
            this.$i18n.t('invalid-file-format') as string,
            {
                title: this.$i18n.t('error') as string,
                variant: 'danger',
                solid: true,
            },
        );
    }
    private rosterCustomAPI() {
        this.isLoading = true;
        rosterAPI.uploadCustomRoster(this.rosterFile, this.userId, this.tenantId, this.selectedCustomType).
        then((responce: any) => {
            this.rosterFile = null;
            this.isUploadedSuccessfully = true;
            this.isLoading = false;
            this.isRefreshRosterdata = !this.isRefreshRosterdata;
        }).catch((error: any) => {
            this.isUploadedSuccessfully = false;
            this.isLoading = false;
            this.validationToastMessage();
        });
    }
    private noScrollable() {
        const element: HTMLElement | any =  document.querySelector('body');
        element.style.overflow = 'auto';
    }
}
